export default {
  props: {
    width: {
      type: String,
      default: "100%"
    },
    showButtonClose: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      show: false
    };
  },
  methods: {
    close: function () {
      this.$emit("close");
    },
    ok: function () {
      this.$emit("ok");
    },
    unShow: function () {
      this.show = false;
      setTimeout(this.close, 600);
    }
  },
  mounted() {
    this.show = true;
  }
};
